import { BackendHttpError } from '../../../services/axiosConfig';

export class LimitPerSideRuleError extends Error {
  public static readonly code = 10;
}

export class CannotFindPreferredSlotError extends Error {
  public static readonly code = 20;
}

export const mapApiError = (error: BackendHttpError): Error => {
  switch (error.code) {
    case LimitPerSideRuleError.code:
      return new LimitPerSideRuleError(error.message);
    case CannotFindPreferredSlotError.code:
      return new CannotFindPreferredSlotError(error.message);
    default:
      return new Error(error.message);
  }
};
